import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Input, Row, Form, DatePicker } from 'antd';
import { VDSRequestResultModal } from '../../containers';
import dayjs from '../../utils/dayjs';
import { v4 as uuidv4 } from 'uuid';

export class VDSTransmissionCancellationForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onReset: PropTypes.func,
    children: PropTypes.any,
    request: PropTypes.any,
    response: PropTypes.any,
    data: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      resultsModalShown: false,
    };
  }

  componentDidMount() {
    const { data } = this.props;
    if (data && data.MessageID) {
      this.formRef.current?.setFieldsValue({
        TransferID: data.MessageID,
      });
    }
    this.resetCancelID();
    this.resetCancelTime();
  }

  resetCancelID() {
    this.formRef.current?.setFieldsValue({
      CancelID: uuidv4(),
    });
  }

  resetCancelTime() {
    this.formRef.current?.setFieldsValue({
      CancelTime: dayjs(),
    });
  }

  submit = (values) => {
    this.props.onSubmit?.(values);
  };

  reset = () => {
    this.formRef.current?.resetFields();
    this.resetCancelID();
    this.resetCancelTime();
    this.props.onReset?.();
  };

  showResult = () => {
    this.setState({ resultsModalShown: true });
  };

  hideResult = () => {
    this.setState({ resultsModalShown: false });
  };

  render() {
    const { children, request, response } = this.props;
    const { resultsModalShown } = this.state;

    return (
      <Form ref={this.formRef} onFinish={this.submit} layout="vertical">
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label="CancelID"
              name="CancelID"
              rules={[
                { required: true, message: 'Sisesta CancelID' },
                { max: 50, message: 'Maksimaalne pikkus on 50' },
              ]}
            >
              <Input placeholder="CancelID" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="TransferID"
              name="TransferID"
              rules={[
                { required: true, message: 'Sisesta TransferID' },
                { max: 50, message: 'Maksimaalne pikkus on 50' },
              ]}
            >
              <Input placeholder="TransferID" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="CancelTime"
              name="CancelTime"
              rules={[{ required: true, message: 'Sisesta CancelTime' }]}
            >
              <DatePicker
                className="w-100"
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD HH:mm"
                placeholder="CancelTime"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col className="form-footer">
            <Button htmlType="submit" type="primary">
              Saada
            </Button>
            <Button onClick={this.reset}>Puhasta</Button>
            <Button onClick={this.showResult} disabled={!request}>
              Päringu tulemus
            </Button>
          </Col>
        </Row>
        {children}
        <VDSRequestResultModal
          request={request}
          response={response}
          show={resultsModalShown}
          hideModal={this.hideResult}
        />
      </Form>
    );
  }
}

export default VDSTransmissionCancellationForm;
